import '../styles/components/Footer.css';
import { Link } from 'react-router-dom';
import { m } from 'framer-motion';
import { staggerContainer, staggerItem, viewport } from '../motion/variants';
import RafikiChatWidget from './RafikiChatWidget';

function IconFacebook() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
      />
    </svg>
  );
}

function IconInstagram() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z"
      />
    </svg>
  );
}

function IconTikTok() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.28 6.28 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.33-6.34V8.69a8.18 8.18 0 0 0 4.78 1.52V6.76a4.85 4.85 0 0 1-1.01-.07z"
      />
    </svg>
  );
}

function IconThreads() {
  return (
    <svg viewBox="0 0 16 16" width="20" height="20" fill="currentColor" aria-hidden="true">
      <path d="M6.321 6.016c-.27-.18-1.166-.802-1.166-2.555 0-1.48.947-2.595 2.294-2.595 1.06 0 1.871.576 2.166 1.454.067.197.067.424 0 .621-.295.878-1.106 1.454-2.166 1.454-1.347 0-2.294-1.115-2.294-2.595 0-1.753.896-2.375 1.166-2.555.25-.167.562-.25.875-.25h1.25c.313 0 .625.083.875.25.27.18 1.166.802 1.166 2.555 0 1.48-.947 2.595-2.294 2.595-1.06 0-1.871-.576-2.166-1.454a1.05 1.05 0 0 1 0-.621c.295-.878 1.106-1.454 2.166-1.454 1.347 0 2.294 1.115 2.294 2.595 0 1.753-.896 2.375-1.166 2.555a1.48 1.48 0 0 1-.875.25H7.196c-.313 0-.625-.083-.875-.25z" />
      <path d="M8 0C5.827 0 5.555.01 4.702.048 3.85.087 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7.01 5.555 0 5.827 0 8.001c0 2.173.01 2.445.048 3.298.039.852.174 1.433.372 1.942.205.526.478.972.923 1.417.444.445.89.719 1.416.923.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16c2.173 0 2.445-.01 3.298-.048.852-.039 1.433-.174 1.942-.372a3.9 3.9 0 0 0 1.417-.923c.445-.445.719-.89.923-1.417.198-.51.333-1.09.372-1.942.039-.853.048-1.125.048-3.298 0-2.173-.01-2.445-.048-3.298-.039-.852-.174-1.433-.372-1.942a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.942-.372C10.445.01 10.173 0 8 0zm0 1.44c2.136 0 2.389.007 3.262.043.78.036 1.204.166 1.487.275.373.145.64.319.92.599.28.28.453.546.598.92.11.283.24.707.275 1.487.037.873.043 1.126.043 3.262s-.006 2.389-.043 3.262c-.036.78-.166 1.204-.275 1.487a2.47 2.47 0 0 1-.599.919c-.28.28-.546.453-.92.598-.283.11-.707.24-1.487.275-.873.037-1.126.043-3.262.043s-2.389-.006-3.262-.043c-.78-.036-1.204-.166-1.487-.275a2.47 2.47 0 0 1-.92-.598 2.47 2.47 0 0 1-.598-.92c-.11-.283-.24-.707-.275-1.487C1.44 10.389 1.433 10.136 1.433 8s.007-2.389.043-3.262c.036-.78.166-1.204.275-1.487.145-.373.319-.64.599-.92.28-.28.546-.453.92-.598.283-.11.707-.24 1.487-.275C5.61 1.447 5.864 1.44 8 1.44z" />
    </svg>
  );
}

function IconWhatsApp() {
  return (
    <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
      <path
        fill="currentColor"
        d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.074-.297-.149-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
      />
    </svg>
  );
}

function IconPhone() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
      />
    </svg>
  );
}

function IconMail() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
      />
    </svg>
  );
}

function IconLocation() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z"
      />
    </svg>
  );
}

function IconMailbox() {
  return (
    <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true">
      <path
        fill="currentColor"
        d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
      />
    </svg>
  );
}

const socialLinks = [
  { href: 'https://www.facebook.com/share/1Cr4jBNHgp/?mibextid=wwXIfr', label: 'Facebook', Icon: IconFacebook },
  { href: 'https://www.instagram.com/ablconstructionlimited/', label: 'Instagram', Icon: IconInstagram },
  { href: 'https://www.tiktok.com/@ablconstructionlimited?_r=1&_t=ZS-96VuG1dgh1T', label: 'TikTok', Icon: IconTikTok },
  { href: 'https://www.threads.com/@ablconstructionlimited?igshid=NTc4MTIwNjQ2YQ==', label: 'Threads', Icon: IconThreads },
  { href: 'https://wa.me/255625313162', label: 'WhatsApp', Icon: IconWhatsApp },
];

const quickLinks = [
  { to: '/land-plot', label: 'Land Plot' },
  { to: '/#about', label: 'About Us' },
  { to: '/#services', label: 'Services' },
  { to: '/#projects', label: 'Projects' },
  { to: '/aggregates', label: 'Pebbles Category' },
  { to: '/contact', label: 'Contact Us' },
];

const contactItems = [
  {
    icon: IconPhone,
    label: 'Phone',
    content: (
      <a href="tel:+255625313162">+255 625 313 162</a>
    ),
  },
  {
    icon: IconMail,
    label: 'Email',
    content: (
      <a href="mailto:info@ablconstruction.co.tz">info@ablconstruction.co.tz</a>
    ),
  },
  {
    icon: IconMailbox,
    label: 'P.O. Box',
    content: <span>P.O. Box 24614, Dar es Salaam</span>,
  },
  {
    icon: IconLocation,
    label: 'Office',
    content: (
      <span>
        Mwenge Tower, 4th Floor — opposite Mlimani City, Sam Nujoma Road
      </span>
    ),
  },
];

function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="site-footer">
      <div className="footer-accent" aria-hidden="true" />

      <m.div
        className="footer-inner"
        initial="hidden"
        whileInView="visible"
        viewport={viewport}
        variants={staggerContainer}
      >
        <m.div className="footer-brand" variants={staggerItem}>
          <Link className="footer-logo-link" to="/" aria-label="ABL Construction — home">
            <img
              src="/img/samplelogo.jpeg"
              alt=""
              className="footer-logo"
              width="64"
              height="64"
            />
          </Link>
          <p className="footer-brand-name">ABL Construction Limited</p>
          <p className="footer-tagline">
            Trusted construction materials and logistics support across Tanzania.
          </p>
          <ul className="footer-social" aria-label="Social media">
            {socialLinks.map(({ href, label, Icon }) => (
              <li key={label}>
                <m.a
                  className="footer-social-link"
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  whileHover={{ y: -2 }}
                  whileTap={{ scale: 0.95 }}
                >
                  <Icon />
                </m.a>
              </li>
            ))}
          </ul>
        </m.div>

        <m.nav className="footer-nav" aria-labelledby="footer-quick-heading" variants={staggerItem}>
          <h2 id="footer-quick-heading" className="footer-heading">
            Quick Links
          </h2>
          <ul className="footer-links">
            {quickLinks.map(({ to, label }) => (
              <li key={label}>
                <Link to={to}>{label}</Link>
              </li>
            ))}
          </ul>
        </m.nav>

        <m.div className="footer-contact-block" variants={staggerItem}>
          <h2 className="footer-heading">Get in touch</h2>
          <ul className="footer-contact-list">
            {contactItems.map(({ icon: Icon, label, content }) => (
              <li key={label} className="footer-contact-item">
                <span className="footer-contact-icon" aria-hidden="true">
                  <Icon />
                </span>
                <div className="footer-contact-body">{content}</div>
              </li>
            ))}
          </ul>
        </m.div>
      </m.div>

      <div className="footer-bottom">
        <div className="footer-bottom-inner">
          <p className="footer-copy">
            © {year} ABL Construction Limited. All rights reserved.
          </p>
        </div>
      </div>
      <RafikiChatWidget />
    </footer>
  );
}

export default Footer;
